module.exports = __webpack_public_path__ + "static/media/less-cramping-OFF.c3ea7a4f.png";